import React, {createContext, useContext, useMemo, useState} from 'react'

const AuthContext = createContext({})

export function useAuthContext() {
    return useContext(AuthContext)
}

export function AuthProvider({children}) {
    const [user, setUser] = useState({})
    const [organisationList, setOrganisationList] = useState([]);
    const [team, setTeam] = useState();
    const [dashboard, setDashboard] = useState();
    const [teamUser, setTeamUser] = useState([])
    const [allTeams, setAllTeams] = useState([])
    const [youHaveNewMessage, setYouHaveNewMessage] = useState(false)

    const value = useMemo(() => ({
        user, setUser, allTeams, setAllTeams, organisationList, setOrganisationList, team, setTeam, dashboard, setDashboard,teamUser,setTeamUser,youHaveNewMessage,setYouHaveNewMessage
    }), [user, setUser, organisationList, setOrganisationList, team, setTeam, dashboard,teamUser,setTeamUser,allTeams, setAllTeams,youHaveNewMessage,setYouHaveNewMessage],)

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
